import { PredefinedPeriodKey } from '../../period/enums/PredefinedPeriodKey'
import { DateTime } from 'luxon'
import PredefinedPeriodJson from './interfaces/PredefinedPeriodJson'

export default class PredefinedPeriod {
  id: string
  key: PredefinedPeriodKey
  seconds: number
  startDate: DateTime | null
  startHour: number | null
  multiplier: number

  constructor(
    id: string,
    key: PredefinedPeriodKey,
    seconds: number,
    startDate: DateTime | null,
    startHour: number | null,
    multiplier: number,
  ) {
    this.id = id
    this.key = key
    this.seconds = seconds
    this.startDate = startDate
    this.startHour = startHour
    this.multiplier = multiplier
  }

  static fromJson(data: PredefinedPeriodJson) {
    return new this(
      data.id,
      data.key,
      data.seconds,
      data.startDate
        ? DateTime.fromISO(data.startDate.date, {
            zone: data.startDate.timezone,
          })
        : null,
      data.startHour,
      data.multiplier,
    )
  }
}
